export const PAGE_SIZE_OPTIONS = [15, 30, 50, 100];

export const DEFAULT_ERROR_MESSAGE = "필수 입력 항목이에요.";

/** 필수값 누락 토스트. 형식 오류(자릿수 등)보다 이 문구가 우선한다 */
export const REQUIRED_FIELDS_MESSAGE = "필수 항목을 모두 입력해 주세요.";

/** 형식 오류 토스트 */
export const INVALID_FIELDS_MESSAGE = "입력한 항목을 다시 확인해 주세요.";
